import { render, staticRenderFns } from "./unfollow-pop.vue?vue&type=template&id=6d50209e&scoped=true&"
import script from "./unfollow-pop.vue?vue&type=script&lang=js&"
export * from "./unfollow-pop.vue?vue&type=script&lang=js&"
import style0 from "./unfollow-pop.vue?vue&type=style&index=0&id=6d50209e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d50209e",
  null
  
)

export default component.exports